
import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import Cabecalho from '../cabecalho/Cabecalho';
import Rodape from '../rodape/Rodape';
import Menu from '../menu/Menu';
import Titulo from '../titulo/Titulo';
import ModalSelecao from './components/ModalSelecao';

// IMPORTAÇÃO DOS SERVICES
import PontosService from '../../service/pontos';
import RegiaoService from '../../service/regioes';
import UsuariosService from '../../service/usuario';
import NotificacaoService from '../../service/notificacoes';

// =============================================================================
// TELA: NOTIFICAÇÕES  (layout de 2 cards, no padrao de "Nova Designacao")
// =============================================================================
// - Card esquerdo: "Nova Notificacao" (formulario + filtros)
//     * Tipo: Mensagem (sino) / Urgente (pop-up)
//     * Para quem: Todos, Por regiao, Por ponto, Publicador especifico
// - Card direito: "Historico de Notificacoes" (lista + filtro por tipo)
// A parte de Comunicacoes Especiais (automacao + comunicados dinamicos) fica
// na pagina /comunicacoes-especiais (exclusiva do admin).
// =============================================================================

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background: #fff;
`;

const MainContent = styled.main`
    padding-top: 85px;
    padding-left: 260px;
    padding-right: 24px;
    padding-bottom: 60px;
    box-sizing: border-box;
    flex: 1 0 auto;
    @media (max-width: 1200px) and (min-width: 768px) {
        padding-left: 80px;
    }
    @media (max-width: 767px) {
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 16px;
    }
`;

const Container = styled.div`
    padding: 24px;
    max-width: 1200px;
    margin: 0 auto;
    font-family: 'Roboto', sans-serif;
`;

const CardsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: clamp(1rem, 2.5vw, 1.5rem);
    row-gap: clamp(1.1rem, 3vw, 1.75rem);
    width: 100%;
    align-items: start;

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
    }
`;

const Card = styled.div`
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
`;

const CardHeader = styled.div`
    background: #00aaaa;
    color: #f1f7f9;
    padding: 12px 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    font-size: 16px;
    font-weight: 600;
`;

const CardBody = styled.div`
    padding: clamp(0.9rem, 2vw, 1.4rem) clamp(1rem, 3vw, 1.75rem);
    display: flex;
    flex-direction: column;
    gap: 14px;
    flex: 1;
    min-height: 0;
`;

// ===== FORM =====

const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const Label = styled.label`
    font-weight: 600;
    color: #333;
    font-size: 13px;
`;

const Select = styled.select`
    padding: 10px 14px;
    border: 1px solid #c5c5c5;
    background: white;
    color: #333;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    &:focus { border-color: #008080; box-shadow: 0 0 0 2px rgba(0, 128, 128, 0.15); }
    &:disabled { background: #f5f5f5; color: #999; cursor: not-allowed; }
    option { color: #333; background: white; }
`;

const InputText = styled.input`
    padding: 10px 14px;
    border: 1px solid #c5c5c5;
    border-radius: 8px;
    font-size: 14px;
    color: #333;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    &:focus { border-color: #008080; box-shadow: 0 0 0 2px rgba(0, 128, 128, 0.15); }
    &::placeholder { color: #999; }
`;

const TextArea = styled.textarea`
    padding: 10px 14px;
    border: 1px solid #c5c5c5;
    border-radius: 8px;
    font-size: 14px;
    color: #333;
    outline: none;
    min-height: 96px;
    resize: vertical;
    font-family: inherit;
    width: 100%;
    box-sizing: border-box;
    &:focus { border-color: #008080; box-shadow: 0 0 0 2px rgba(0, 128, 128, 0.15); }
    &::placeholder { color: #999; }
`;

const TipoRow = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
`;

const TipoButton = styled.button`
    border: 1px solid #008080;
    background: ${(props) => (props.$active ? '#008080' : '#fff')};
    color: ${(props) => (props.$active ? '#fff' : '#008080')};
    padding: 8px 18px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    &:hover { background: ${(props) => (props.$active ? '#006666' : '#f0fdfd')}; }
`;

const PrimaryButton = styled.button`
    background: #008080;
    border: none;
    color: white;
    padding: 11px 32px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    align-self: center;
    margin-top: 8px;
    &:hover { background: #006666; }
    &:disabled { background: #ccc; cursor: not-allowed; }
`;

const AvisoRegional = styled.span`
    font-size: 11px;
    color: #d32f2f;
`;

// ===== HISTORICO =====

const HistoricoFiltro = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 4px;
`;

const HistoricoLista = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 520px;
    overflow-y: auto;
    padding-right: 4px;
`;

const HistoricoItem = styled.div`
    padding: 12px;
    border-radius: 6px;
    background: #f8f9fa;
    border-left: 4px solid ${(props) => (props.$tipo === 'popup' ? '#DB1212' : '#008080')};
`;

const HistoricoBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: bold;
    color: white;
    background: ${(props) => (props.$tipo === 'popup' ? '#DB1212' : '#008080')};
`;

const HistoricoInfo = styled.div`
    font-size: 12px;
    color: #777;
    margin-top: 4px;
`;

const Loading = styled.div`
    text-align: center;
    padding: 40px;
    color: #008080;
`;

const ErrorMessage = styled.div`
    background: #fde8e8;
    color: #c62828;
    padding: 12px 16px;
    border-radius: 6px;
    margin-bottom: 16px;
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #999;
    font-style: italic;
`;

// ===== SELEÇÃO DE ALVOS (resumo + botão) =====

const AlvosResumo = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border: 1px dashed #c5c5c5;
    border-radius: 8px;
    font-size: 13px;
    color: #333;
`;

const Chip = styled.span`
    background: #e6f7f7;
    color: #00706f;
    border-radius: 14px;
    padding: 3px 10px;
    font-size: 12px;
    font-weight: 600;
`;

const LinkBotao = styled.button`
    border: none;
    background: none;
    color: #008080;
    font-weight: 700;
    font-size: 13px;
    cursor: pointer;
    padding: 0;
    text-decoration: underline;
`;

// ===== CONFIRMAÇÃO =====

const ConfirmOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(30, 41, 59, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 4100;
    padding: 16px;
`;

const ConfirmCard = styled.div`
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.25);
    padding: 28px 32px;
    max-width: 360px;
    text-align: center;
    font-family: 'Roboto', sans-serif;
`;

const ConfirmTitulo = styled.h3`
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
`;

const ConfirmTexto = styled.p`
    margin: 0 0 22px 0;
    font-size: 14px;
    color: #475569;
    line-height: 1.4;
`;

const ConfirmBotoes = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
`;

const ConfirmSim = styled.button`
    background: #22c55e;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 9px 26px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    &:hover { background: #16a34a; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

const ConfirmNao = styled.button`
    background: #ef4444;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 9px 26px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    &:hover { background: #dc2626; }
`;

// ===== TOAST =====

const ToastWrap = styled.div`
    position: fixed;
    top: 90px;
    right: 20px;
    z-index: 4200;
    max-width: 380px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
    display: flex;
    overflow: hidden;
    font-family: 'Roboto', sans-serif;
    animation: slideIn 0.2s ease-out;
    @keyframes slideIn { from { transform: translateX(20px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
`;

const ToastBarra = styled.div`
    width: 6px;
    background: ${(p) => (p.$tipo === 'success' ? '#22c55e' : '#ef4444')};
`;

const ToastCorpo = styled.div`
    padding: 12px 14px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
`;

const ToastIcone = styled.div`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${(p) => (p.$tipo === 'success' ? '#22c55e' : '#ef4444')};
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ToastTitulo = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: #1e293b;
`;

const ToastMsg = styled.div`
    font-size: 12.5px;
    color: #475569;
    margin-top: 2px;
    white-space: pre-wrap;
`;

const ToastFechar = styled.button`
    border: none;
    background: none;
    color: #94a3b8;
    font-size: 16px;
    cursor: pointer;
    align-self: flex-start;
    &:hover { color: #0f172a; }
`;

// =============================================================================
// OPÇÕES DE "SELEÇÃO DE PÚBLICO" POR ESCOPO DO REMETENTE
// (precisa espelhar FILTROS_POR_ESCOPO no backend — notificacao.audiencia.js)
// =============================================================================
const OPCOES_PUBLICO = {
    geral: [
        { v: 'todos', label: 'Todos os Publicadores' },
        { v: 'regiao', label: 'Por Região' },
        { v: 'ponto', label: 'Por Ponto' },
        { v: 'publicador', label: 'Publicador específico' },
        { v: 'coordenadores-regionais', label: 'Todos os Coordenadores Regionais' },
        { v: 'coordenadores-regionais-geral', label: 'Todos os Coord. Regionais e Geral' },
        { v: 'coordenadores-ponto', label: 'Todos os Coordenadores de Ponto' },
        { v: 'coordenadores-ponto-regionais', label: 'Todos os Coord. de Ponto e Regionais' },
    ],
    regional: [
        { v: 'regiao', label: 'Por Região' },
        { v: 'ponto', label: 'Por Ponto' },
        { v: 'publicador', label: 'Publicador específico' },
        { v: 'coordenadores-regionais', label: 'Todos os Coordenadores Regionais' },
        { v: 'coordenadores-regionais-geral', label: 'Todos os Coord. Regionais e Geral' },
        { v: 'coordenadores-ponto', label: 'Todos os Coordenadores de Ponto (da sua região)' },
    ],
    ponto: [
        { v: 'ponto', label: 'Por Ponto' },
        { v: 'publicador', label: 'Publicador específico' },
    ],
    nenhum: [],
};

// Filtros que NÃO precisam de um alvoId (o próprio valor define o grupo)
const FILTROS_COLETIVOS = [
    'todos',
    'coordenadores-regionais', 'coordenadores-regionais-geral',
    'coordenadores-ponto', 'coordenadores-ponto-regionais',
];

// =============================================================================
// COMPONENTE PRINCIPAL
// =============================================================================

const Comunicacoes = () => {
    const userId = typeof window !== 'undefined' ? localStorage.getItem('idUsuario') : null;

    // PERFIS / ESCOPO
    const [perfilUsuario, setPerfilUsuario] = useState([]);
    const [verificandoPerfil, setVerificandoPerfil] = useState(true);
    const escopo = useMemo(() => {
        if (perfilUsuario.includes('admin') || perfilUsuario.includes('coordenador-geral')) return 'geral';
        if (perfilUsuario.includes('coordenador-regional')) return 'regional';
        if (perfilUsuario.includes('coordenador-ponto')) return 'ponto';
        return 'nenhum';
    }, [perfilUsuario]);
    const opcoesPublico = useMemo(() => OPCOES_PUBLICO[escopo] || [], [escopo]);

    // =================== NOVA NOTIFICAÇÃO ===================
    const [tipoMensagem, setTipoMensagem] = useState('mensagem');
    const [filtroAlvo, setFiltroAlvo] = useState('todos');
    const [alvosSelecionados, setAlvosSelecionados] = useState([]); // [{ _id, nome, ... }]
    const [tituloAviso, setTituloAviso] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [regioesBanco, setRegioesBanco] = useState([]);
    const [pontosBanco, setPontosBanco] = useState([]);
    const [loadingNotif, setLoadingNotif] = useState(false);

    // Modais / feedback
    const [modalSelecao, setModalSelecao] = useState(null);   // 'regiao' | 'ponto' | 'publicador' | null
    const [confirmarAberto, setConfirmarAberto] = useState(false);
    const [toast, setToast] = useState({ show: false, tipo: 'success', titulo: '', msg: '' });

    // =================== HISTÓRICO ===================
    const [historico, setHistorico] = useState([]);
    const [filtroHistTipo, setFiltroHistTipo] = useState('todos');

    const [erro, setErro] = useState(null);

    // ====== CARREGAMENTO INICIAL (perfil primeiro, depois listas escopadas) ======
    useEffect(() => {
        const init = async () => {
            if (!userId) { setVerificandoPerfil(false); return; }
            try {
                const dadosUsuario = await UsuariosService.getUsuarioById(userId).catch(() => null);
                const perfis = dadosUsuario
                    ? (Array.isArray(dadosUsuario.perfil) ? dadosUsuario.perfil : (dadosUsuario.perfil ? [dadosUsuario.perfil] : []))
                    : [];
                setPerfilUsuario(perfis);
                try { localStorage.setItem('perfilUsuario', JSON.stringify(perfis)); } catch (e) {}

                const ehGeral = perfis.includes('admin') || perfis.includes('coordenador-geral');
                const ehRegional = !ehGeral && perfis.includes('coordenador-regional');
                const ehPonto = !ehGeral && !ehRegional && perfis.includes('coordenador-ponto');

                // Regiões: geral vê todas; regional/ponto vê só as suas
                const regs = await (ehGeral ? RegiaoService.getRegioes() : RegiaoService.getRegioes(true)).catch(() => []);
                const regioesArr = Array.isArray(regs) ? regs : (regs?.regioes || []);
                setRegioesBanco(regioesArr);
                const regIds = new Set(regioesArr.map(r => String(r._id)));

                // Pontos: ponto vê só os que coordena; regional vê os pontos das suas regiões; geral vê todos
                const pts = await (ehPonto ? PontosService.getPontos(true) : PontosService.getPontos()).catch(() => []);
                let pontosArr = Array.isArray(pts) ? pts : (pts?.pontos || []);
                if (ehRegional) {
                    pontosArr = pontosArr.filter(p => regIds.has(String(p.regiao?._id || p.regiao)));
                }
                setPontosBanco(pontosArr);
            } catch (err) {
                console.error('Erro ao inicializar Notificacoes:', err);
            } finally {
                setVerificandoPerfil(false);
            }
        };
        init();
    }, [userId]);

    // Ajusta o filtro para uma opção válida do escopo do remetente
    useEffect(() => {
        if (verificandoPerfil || escopo === 'nenhum') return;
        const validos = (OPCOES_PUBLICO[escopo] || []).map(o => o.v);
        if (!validos.includes(filtroAlvo)) {
            setFiltroAlvo(validos[0] || 'todos');
            setAlvosSelecionados([]);
        }
    }, [escopo, verificandoPerfil, filtroAlvo]);

    // Carrega historico quando perfis estiverem prontos
    useEffect(() => {
        if (!verificandoPerfil) carregarHistorico();
    }, [verificandoPerfil]);

    const carregarHistorico = async () => {
        try {
            const hist = await NotificacaoService.getHistorico();
            setHistorico(Array.isArray(hist) ? hist : []);
        } catch (err) {
            console.error('Erro ao carregar historico:', err);
        }
    };

    // ====== FILTROS DE ALVO (listas já vêm escopadas do carregamento inicial) ======
    const regioesPermitidas = regioesBanco;
    const pontosPermitidos = pontosBanco;
    const pontosIdsEscopo = useMemo(() => pontosBanco.map(p => p._id), [pontosBanco]);

    // Publicadores com disponibilidade nos pontos do escopo (regional / coord de ponto)
    const [pubDisponiveis, setPubDisponiveis] = useState([]);
    const [pubDisponiveisLoading, setPubDisponiveisLoading] = useState(false);

    useEffect(() => {
        if (filtroAlvo !== 'publicador' || escopo === 'geral' || escopo === 'nenhum') return;
        if (pontosIdsEscopo.length === 0) { setPubDisponiveis([]); return; }
        let cancelado = false;
        setPubDisponiveisLoading(true);
        UsuariosService.listarDisponiveisPorPonto(pontosIdsEscopo)
            .then(lista => { if (!cancelado) setPubDisponiveis(Array.isArray(lista) ? lista : []); })
            .catch(() => { if (!cancelado) setPubDisponiveis([]); })
            .finally(() => { if (!cancelado) setPubDisponiveisLoading(false); });
        return () => { cancelado = true; };
    }, [filtroAlvo, escopo, pontosIdsEscopo]);

    const precisaAlvo = !FILTROS_COLETIVOS.includes(filtroAlvo);

    const mostrarToast = (tipo, titulo, msg) => {
        setToast({ show: true, tipo, titulo, msg });
        window.clearTimeout(mostrarToast._t);
        mostrarToast._t = window.setTimeout(() => setToast(t => ({ ...t, show: false })), 7000);
    };

    // Troca de "Seleção de público" — abre o modal quando o alvo exige seleção
    const handleTrocarFiltro = (v) => {
        setFiltroAlvo(v);
        setAlvosSelecionados([]);
        if (['regiao', 'ponto', 'publicador'].includes(v)) setModalSelecao(v);
    };

    // Config do modal conforme o alvo atual
    const modalConfig = useMemo(() => {
        if (modalSelecao === 'regiao') {
            return {
                titulo: 'Regiões',
                itens: regioesPermitidas,
                buscaKeys: ['nome'],
                colunas: [
                    { label: 'Regiões', render: (r) => r.nome },
                    { label: '', render: () => '' },
                ],
            };
        }
        if (modalSelecao === 'ponto') {
            return {
                titulo: 'Pontos',
                itens: pontosPermitidos,
                buscaKeys: ['nome', 'local'],
                colunas: [
                    { label: 'Pontos', render: (p) => <>{p.nome}{p.local ? <small>{p.local}</small> : null}</> },
                    { label: 'Local', render: (p) => p.local || '' },
                ],
            };
        }
        if (modalSelecao === 'publicador') {
            if (escopo === 'geral') {
                return {
                    titulo: 'Publicadores',
                    fetchPage: ({ search, page, limit }) =>
                        UsuariosService.buscarSimples({ search, page, limit, filtroPerfil: 'publicadores' }),
                    colunas: [
                        { label: 'Nome', render: (u) => <>{u.nome}{u.telefone || u.email ? <small>{u.telefone || u.email}</small> : null}</> },
                        { label: 'Usuário', render: (u) => u.usuario || u.email || '' },
                    ],
                };
            }
            return {
                titulo: 'Publicadores',
                itens: pubDisponiveis,
                buscaKeys: ['nome', 'email'],
                colunas: [
                    {
                        label: 'Nome',
                        render: (u) => {
                            const flags = [u.temFcmToken === false ? 'sem app' : null, u.ativo === false ? 'inativo' : null].filter(Boolean);
                            return <>{u.nome}{flags.length ? <small>{flags.join(' · ')}</small> : null}</>;
                        },
                    },
                    { label: '', render: () => '' },
                ],
            };
        }
        return null;
    }, [modalSelecao, regioesPermitidas, pontosPermitidos, pubDisponiveis, escopo]);

    // ====== ENVIAR NOTIFICACAO (abre a confirmação) ======
    const handleEnviarNotif = (e) => {
        e.preventDefault();
        setErro(null);
        if (!tituloAviso.trim() || !mensagem.trim()) {
            mostrarToast('error', 'Erro', 'Preencha título e mensagem.');
            return;
        }
        if (precisaAlvo && alvosSelecionados.length === 0) {
            mostrarToast('error', 'Erro', 'Selecione ao menos um alvo.');
            return;
        }
        setConfirmarAberto(true);
    };

    // ====== CONFIRMA E ENVIA DE FATO ======
    const confirmarEnvio = async () => {
        setConfirmarAberto(false);
        setLoadingNotif(true);
        try {
            const resposta = await NotificacaoService.enviarNotificacao({
                tipoMensagem,
                titulo: tituloAviso,
                mensagem,
                filtroAlvo,
                alvoIds: precisaAlvo ? alvosSelecionados.map(a => a._id) : [],
            });
            const qtd = resposta?.enviosComSucesso ?? resposta?.sucessos ?? 0;
            const total = resposta?.totalDestinatarios;

            if (resposta?.diagnostico) {
                mostrarToast('error', 'Erro ao enviar a notificação.', resposta.diagnostico);
            } else if (qtd === 0) {
                mostrarToast('error', 'Erro ao enviar a notificação.', 'Nenhum destinatário recebeu (ninguém com FCM token). O publicador precisa abrir o app pelo menos uma vez.');
            } else {
                const detalhe = (typeof total === 'number' && total !== qtd)
                    ? `Enviada para ${qtd} de ${total} dispositivo(s).`
                    : `Enviada para ${qtd} dispositivo(s).`;
                mostrarToast('success', 'Sucesso', `Notificação enviada com sucesso. ${detalhe}`);
                setTituloAviso('');
                setMensagem('');
                setAlvosSelecionados([]);
            }
            await carregarHistorico();
        } catch (error) {
            const status = error?.response?.status;
            const msgBackend = error?.response?.data?.erro;
            mostrarToast('error', 'Erro ao enviar a notificação.', `${status ? `Erro ${status}: ` : ''}${msgBackend || error?.message || 'Falha desconhecida.'}`);
        } finally {
            setLoadingNotif(false);
        }
    };

    const historicoFiltrado = useMemo(() => {
        if (filtroHistTipo === 'todos') return historico;
        return historico.filter(h => h.tipo === filtroHistTipo);
    }, [historico, filtroHistTipo]);

    const formatarData = (iso) => {
        if (!iso) return '-';
        try { return new Date(iso).toLocaleString('pt-BR'); } catch { return iso; }
    };

    // ====== RENDER ======
    if (verificandoPerfil) {
        return (
            <PageWrapper>
                <Menu />
                <Cabecalho />
                <MainContent>
                    <Container>
                        <Loading>Verificando permissoes...</Loading>
                    </Container>
                </MainContent>
            </PageWrapper>
        );
    }

    if (escopo === 'nenhum') {
        return (
            <PageWrapper>
                <Menu />
                <Cabecalho />
                <MainContent>
                    <Container>
                        <Titulo>Acesso Negado</Titulo>
                        <p>Voce nao tem permissao para acessar Notificações.</p>
                    </Container>
                </MainContent>
            </PageWrapper>
        );
    }

    return (
        <PageWrapper>
            <Menu />
            <Cabecalho />
            <MainContent>
                <Container>
                    <Titulo>Notificações</Titulo>

                    {erro && <ErrorMessage>{erro}</ErrorMessage>}

                    <CardsWrapper>
                        {/* ============== CARD ESQUERDO: NOVA NOTIFICACAO ============== */}
                        <Card>
                            <CardHeader>Nova Notificação</CardHeader>
                            <CardBody>
                                <form onSubmit={handleEnviarNotif} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                                    <FormGroup>
                                        <Label>Título:</Label>
                                        <InputText
                                            type="text"
                                            value={tituloAviso}
                                            onChange={(e) => setTituloAviso(e.target.value)}
                                            placeholder="Insira o título"
                                            maxLength={100}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Tipo:</Label>
                                        <TipoRow>
                                            <TipoButton
                                                type="button"
                                                $active={tipoMensagem === 'mensagem'}
                                                onClick={() => setTipoMensagem('mensagem')}
                                            >
                                                Mensagem
                                            </TipoButton>
                                            <TipoButton
                                                type="button"
                                                $active={tipoMensagem === 'popup'}
                                                onClick={() => setTipoMensagem('popup')}
                                            >
                                                Urgente
                                            </TipoButton>
                                        </TipoRow>
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Mensagem:</Label>
                                        <TextArea
                                            value={mensagem}
                                            onChange={(e) => setMensagem(e.target.value)}
                                            placeholder="Escreva uma mensagem"
                                            maxLength={1000}
                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>Seleção de público:</Label>
                                        <Select
                                            value={filtroAlvo}
                                            onChange={(e) => handleTrocarFiltro(e.target.value)}
                                        >
                                            {opcoesPublico.map(o => (
                                                <option key={o.v} value={o.v}>{o.label}</option>
                                            ))}
                                        </Select>
                                        {escopo === 'regional' && (
                                            <AvisoRegional>Escopo do coordenador regional: suas regiões e pontos.</AvisoRegional>
                                        )}
                                        {escopo === 'ponto' && (
                                            <AvisoRegional>Escopo do coordenador de ponto: seus pontos.</AvisoRegional>
                                        )}
                                    </FormGroup>

                                    {precisaAlvo && (
                                        <FormGroup>
                                            <Label>
                                                {filtroAlvo === 'regiao' ? 'Regiões selecionadas:'
                                                    : filtroAlvo === 'ponto' ? 'Pontos selecionados:'
                                                    : 'Publicadores selecionados:'}
                                            </Label>
                                            <AlvosResumo>
                                                {filtroAlvo === 'publicador' && escopo !== 'geral' && pubDisponiveisLoading ? (
                                                    <span style={{ color: '#999' }}>Carregando publicadores…</span>
                                                ) : alvosSelecionados.length === 0 ? (
                                                    <span style={{ color: '#999' }}>Nenhum selecionado.</span>
                                                ) : (
                                                    alvosSelecionados.map(a => <Chip key={a._id}>{a.nome}</Chip>)
                                                )}
                                                <LinkBotao type="button" onClick={() => setModalSelecao(filtroAlvo)}>
                                                    {alvosSelecionados.length === 0 ? 'Selecionar' : 'Alterar seleção'}
                                                </LinkBotao>
                                                {alvosSelecionados.length > 0 && (
                                                    <LinkBotao
                                                        type="button"
                                                        style={{ color: '#c62828' }}
                                                        onClick={() => setAlvosSelecionados([])}
                                                    >
                                                        Limpar seleção
                                                    </LinkBotao>
                                                )}
                                            </AlvosResumo>
                                        </FormGroup>
                                    )}

                                    <PrimaryButton type="submit" disabled={loadingNotif}>
                                        {loadingNotif ? 'Enviando...' : 'Enviar'}
                                    </PrimaryButton>
                                </form>
                            </CardBody>
                        </Card>

                        {/* ============== CARD DIREITO: HISTORICO ============== */}
                        <Card>
                            <CardHeader>Histórico de Notificações</CardHeader>
                            <CardBody>
                                <HistoricoFiltro>
                                    <Label>Filtrar por tipo:</Label>
                                    <Select value={filtroHistTipo} onChange={(e) => setFiltroHistTipo(e.target.value)}>
                                        <option value="todos">Todos</option>
                                        <option value="mensagem">Mensagens</option>
                                        <option value="popup">Urgentes</option>
                                    </Select>
                                </HistoricoFiltro>

                                <HistoricoLista>
                                    {historicoFiltrado.length === 0 ? (
                                        <EmptyState>Sem notificações no histórico ainda.</EmptyState>
                                    ) : (
                                        historicoFiltrado.map((h) => (
                                            <HistoricoItem key={h._id} $tipo={h.tipo}>
                                                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                                    <HistoricoBadge $tipo={h.tipo}>{h.tipo === 'popup' ? 'URGENTE' : 'MENSAGEM'}</HistoricoBadge>
                                                    <strong style={{ fontSize: 14 }}>{h.titulo}</strong>
                                                </div>
                                                <div style={{ fontSize: 13, color: '#555', marginTop: 4 }}>{h.mensagem}</div>
                                                <HistoricoInfo>
                                                    📅 {formatarData(h.createdAt)} · de {h.enviadoPor?.nome || 'Sistema'}
                                                </HistoricoInfo>
                                            </HistoricoItem>
                                        ))
                                    )}
                                </HistoricoLista>
                            </CardBody>
                        </Card>
                    </CardsWrapper>
                </Container>
            </MainContent>
            <Rodape />

            {/* ===== Modal de seleção de alvos ===== */}
            {modalSelecao && modalConfig && (
                <ModalSelecao
                    titulo={modalConfig.titulo}
                    colunas={modalConfig.colunas}
                    itens={modalConfig.itens || null}
                    fetchPage={modalConfig.fetchPage || null}
                    buscaKeys={modalConfig.buscaKeys || ['nome']}
                    selecionados={alvosSelecionados}
                    onConfirmar={(lista) => setAlvosSelecionados(lista)}
                    onFechar={() => setModalSelecao(null)}
                />
            )}

            {/* ===== Confirmação de envio ===== */}
            {confirmarAberto && (
                <ConfirmOverlay onMouseDown={(e) => { if (e.target === e.currentTarget) setConfirmarAberto(false); }}>
                    <ConfirmCard>
                        <ConfirmTitulo>Confirmar envio</ConfirmTitulo>
                        <ConfirmTexto>Tem certeza de que deseja enviar esta mensagem?</ConfirmTexto>
                        <ConfirmBotoes>
                            <ConfirmSim type="button" onClick={confirmarEnvio} disabled={loadingNotif}>
                                {loadingNotif ? 'Enviando…' : 'SIM'}
                            </ConfirmSim>
                            <ConfirmNao type="button" onClick={() => setConfirmarAberto(false)}>NÃO</ConfirmNao>
                        </ConfirmBotoes>
                    </ConfirmCard>
                </ConfirmOverlay>
            )}

            {/* ===== Toast ===== */}
            {toast.show && (
                <ToastWrap>
                    <ToastBarra $tipo={toast.tipo} />
                    <ToastCorpo>
                        <ToastIcone $tipo={toast.tipo}>{toast.tipo === 'success' ? '✓' : '!'}</ToastIcone>
                        <div>
                            <ToastTitulo>{toast.titulo}</ToastTitulo>
                            {toast.msg && <ToastMsg>{toast.msg}</ToastMsg>}
                        </div>
                        <ToastFechar type="button" onClick={() => setToast(t => ({ ...t, show: false }))}>×</ToastFechar>
                    </ToastCorpo>
                </ToastWrap>
            )}
        </PageWrapper>
    );
};

export default Comunicacoes;
